import request from "@/request";

//任务列表
export function check_list(data) {
  return request({
    url: "association_check/list",
    method: "post",
    data,
  });
}

//任务查看详情
export function ass_check_detail(data) {
  return request({
    url: "association_check/detail",
    method: "post",
    data,
  });
}

//任务查看详情
export function ass_check_detail_copy(data) {
  return request({
    url: "association_check/detail_copy",
    method: "post",
    data,
  });
}

//任务审核页面
export function ass_check_check(data) {
  return request({
    url: "association_check/check",
    method: "post",
    data,
  });
}

//内容提交审核
export function ass_check_content(data) {
  return request({
    url: "association_check/submit_content",
    method: "post",
    data,
  });
}

//产品状态列表
export function ass_check_status(data) {
  return request({
    url: "association_check/script_staus_watch",
    method: "post",
    data,
  });
}

//已删除产品列表
export function ass_query_record_list(data) {
  return request({
    url: "association_check/script_copy",
    method: "post",
    data,
  });
}

/* 建议完成数量确认 */
export function approved_number(data) {
  return request({
    url: "specialist_check/approved_number",
    method: "post",
    data,
  });
}

//建议修改
export function ass_first_modify(data) {
  return request({
    url: "association_check/modify",
    method: "post",
    data,
  });
}

//二次建议修改
export function ass_second_modify(data) {
  return request({
    url: "association_check/approve_fail",
    method: "post",
    data,
  });
}

//提交协会
export function ass_save_check(data) {
  return request({
    url: "association_check/approved",
    method: "post",
    data,
  });
}

//协会审核结果列表
export function result_list(data) {
  return request({
    url: "association_check/result_list",
    method: "post",
    data,
  });
}

//协会批量审核
export function all_approved(data) {
  return request({
    url: "association_check/all_approved",
    method: "post",
    data,
  });
}

//协会查看剧本第一次详情
export function first_detail(data) {
  return request({
    url: "association_check/first_detail",
    method: "post",
    data,
  });
}

/* ------------------------------------协会最终公式------------------------------------ */
//评测内容公示列表
export function publicity_task_list(data) {
  return request({
    url: "department_task/publicity_task_list",
    method: "post",
    data,
  });
}

//单个评测内容公示
export function publicity_task_one_pub(data) {
  return request({
    url: "department_task/publicity_task_one_pub",
    method: "post",
    data,
  });
}

//批量评测内容公示
export function publicity_task_batch_pub(data) {
  return request({
    url: "department_task/publicity_task_batch_pub",
    method: "post",
    data,
  });
}

/* ------------------------------------协会专家分配------------------------------------ */
//剧本分配专家记录(日志)
export function specialist_allot_history(data) {
  return request({
    url: "script_log/specialist_allot_history" + data,
    method: "get",
    // data
  });
}
//审核日志
export function script_node_log(data) {
  return request({
    url: "script_log/script_node_log" + data,
    method: "get",
    // data
  });
}

//分配内容审核专家任务列表
export function department_task_list(data) {
  return request({
    url: "department_task/department_task_list",
    method: "post",
    data,
  });
}
//分配评测专家任务列表
export function department_task_age_list(data) {
  return request({
    url: "department_task/department_task_age_list",
    method: "post",
    data,
  });
}

//拉取所有专家
export function list_with_premission(data) {
  return request({
    url: "department_task/get_specialist_list_with_premission",
    method: "get",
    data,
  });
}

//分配内容审核/评测专家人员列表
export function get_specialist_list(data) {
  return request({
    url: "department_task/get_specialist_list?" + data,
    method: "get",
  });
}

//单个分配到内容审核专家
export function department_task_one_allot(data) {
  return request({
    url: "department_task/department_task_one_allot",
    method: "post",
    data,
  });
}

//单个分配到评测专家
export function task_one_allot_age(data) {
  return request({
    url: "department_task/department_task_one_allot_age",
    method: "post",
    data,
  });
}

//多个分配到专家
export function department_task_batch_allot(data) {
  return request({
    url: "department_task/department_task_batch_allot",
    method: "post",
    data,
  });
}
//多个分配到适龄专家
export function department_task_batch_allot_age(data) {
  return request({
    url: "department_task/department_task_batch_allot_age",
    method: "post",
    data,
  });
}

/* ------------------------------------专家审核任务------------------------------------ */
/* 内容审核专家审核任务列表 */
export function specialist_check(data) {
  return request({
    url: "specialist_check/list",
    method: "post",
    data,
  });
}
/* 评测专家审核任务列表 */
export function age_specialist_task_list(data) {
  return request({
    url: "department_task/age_specialist_task_list?" + data,
    method: "get",
  });
}
/*  */
/* 专家合议任务列表 */
export function discussion_list(data) {
  return request({
    url: "specialist_check/discussion_list",
    method: "post",
    data,
  });
}

/* 专家任务审核 */
export function specialist_info(data) {
  return request({
    url: "specialist_check/check",
    method: "post",
    data,
  });
}
/* 专家任务查看 */
export function specialist_detail(data) {
  return request({
    url: "specialist_check/detail",
    method: "post",
    data,
  });
}

/* 获取当前专家权限 */
export function get_specialist_premission(data) {
  return request({
    url: "department_task/get_specialist_all_premission?" + data,
    method: "get",
    data,
  });
}

/* 专家标签拉取 */
export function get_specialist_label_list(data) {
  return request({
    url: "department_task/get_specialist_label_list/?" + data,
    method: "get",
  });
}

/* 专家为剧本绑定标签 */
export function age_specialist_bind_label(data) {
  return request({
    url: "department_task/age_specialist_bind_label",
    method: "post",
    data,
  });
}

/* 专家内容审核 */
export function specialist_submit_content(data) {
  return request({
    url: "specialist_check/submit_content",
    method: "post",
    data,
  });
}

/* 专家合议审核内容 */
export function specialist_save_edit_content(data) {
  return request({
    url: "specialist_check/save_edit_content",
    method: "post",
    data,
  });
}

/* 专家修改审核内容 */
export function specialist_modify(data) {
  return request({
    url: "specialist_check/modify",
    method: "post",
    data,
  });
}

/* 专家完成接口 */
export function specialist_approved(data) {
  return request({
    url: "specialist_check/approved",
    method: "post",
    data,
  });
}

/* 合议内容删除 */
export function save_delete_content(data) {
  return request({
    url: "specialist_check/save_delete_content",
    method: "post",
    data,
  });
}

/* 列表里面的单个分配专家 */
export function department_task_one_allot_age(data) {
  return request({
    url: "department_task/department_task_one_allot_age",
    method: "post",
    data,
  });
}

/* 专家查看一次剧本信息 */
export function spe_first_detail(data) {
  return request({
    url: "specialist_check/first_detail",
    method: "post",
    data,
  });
}

/* ----------合议---------- */
/* 专家查看合议详情 */
export function discussion_detail(data) {
  return request({
    url: "specialist_check/discussion_detail",
    method: "post",
    data,
  });
}

/* 专家同意单个合议 */
export function agree_discussion(data) {
  return request({
    url: "specialist_check/agree_discussion",
    method: "post",
    data,
  });
}

/* 专家完成所有合议 */
export function finish_edit(data) {
  return request({
    url: "specialist_check/finish_edit",
    method: "post",
    data,
  });
}

/* 合议完成数量确认 */
export function finish_edit_number(data) {
  return request({
    url: "specialist_check/finish_edit_number",
    method: "post",
    data,
  });
}

/* 专家全局建议 */
export function suggest(data) {
  return request({
    url: "specialist_check/suggest",
    method: "post",
    data,
  });
}

/* 合议完成数量确认 */
export function check_man_log(data) {
  return request({
    url: "association_check/check_man_log",
    method: "post",
    data,
  });
}

/* 沟通列表 */
export function communication_list(data) {
  return request({
    url: "association_check/communication_list",
    method: "post",
    data,
  });
}

/* 沟通详情 */
export function communication_detail(data) {
  return request({
    url: "association_check/communication_detail",
    method: "post",
    data,
  });
}

/* 沟通完成 */
export function communication_finish(data) {
  return request({
    url: "association_check/communication_finish",
    method: "post",
    data,
  });
}

/* 公众号公示列表 */
export function gzh_publicity_list(data) {
  return request({
    url: "department_task/gzh_publicity_list",
    method: "post",
    data,
  });
}

/* 生成新的批次号 */
export function gzh_make_publicity_edition(data) {
  return request({
    url: "department_task/gzh_make_publicity_edition",
    method: "get",
  });
}

/* 批量公示提交 */
export function gzh_batch_publicity(data) {
  return request({
    url: "department_task/gzh_batch_publicity",
    method: "post",
    data,
  });
}

/* 公众号批次号列表 */
export function gzh_publicity_edition_list(data) {
  return request({
    url: "department_task/gzh_publicity_edition_list",
    method: "get",
  });
}

//审核机构列表
export function publish_list(data) {
  return request({
    url: "publish/list",
    method: "post",
    data,
  });
}
